<script setup>
const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
  animated: {
    type: Boolean,
    default: true,
  },
  isError: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
  <div class="progress-bar-wrapper">
    <div
      class="progress-bar-fill"
      :class="{
        'animated-striped': props.animated && props.value !== 100,
        'progress-bar-fill__is-error': props.isError
      }"
      :style="{ width: props.value + '%' }"
    />
  </div>
</template>

<style scoped lang="scss">
.progress-bar-wrapper {
  min-width: 150px;
  width: 100%;
  height: 10px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background-color: #44ff8f;
  border-radius: 4px;
  transition: width 1s ease;
  &__is-error {
    background-color: $color-error;
  }
}

.progress-bar-fill.animated-striped {
  background-image: repeating-linear-gradient(
    45deg,
    #44ff8f,
    #44ff8f 20%,
    #3be682 20%,
    #3be682 60%
  );
  background-size: 40px 40px;
  animation: move-stripes 1s linear infinite;
}

.progress-bar-fill__is-error.animated-striped {
  background-image: repeating-linear-gradient(
    45deg,
    #ff4d4f,
    #ff4d4f 20%,
    #e63b3b 20%,
    #e63b3b 60%
  );
}

@keyframes move-stripes {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 40px 0;
  }
}

</style>
